import styled from 'styled-components'
import { Modal } from '../../Modal'
import { StyledModalContent } from '../../Modal/Modal.styles'
import { Page } from '../../PageLayout'
import {
  StyledAsideFluidContainer,
  StyledAsidePanel,
} from '../../PageLayout/PageLayout.styles'
import { mediaBreakpointsDown } from '../../PageLayout/PageLayout.utils'
import { StyledFooter as StyledPanelFooter } from '../../Panel/Panel.styles'
import { spacing } from '../../_styles/spacing'

const panelWidthSmall = 360
export const mobileBreakpoint = 440

export const StyledPageAside = styled(Page.Aside)`
  position: sticky;
  top: 0;
  right: 0;
  max-height: 100vh;
  width: 100%;
  height: 100%;

  @media ${mediaBreakpointsDown.tabletLg} {
    position: sticky;
    max-width: ${panelWidthSmall}px;
    flex-basis: ${panelWidthSmall}px;
  }

  ${StyledAsideFluidContainer} {
    @media ${mediaBreakpointsDown.tabletLg} {
      max-width: ${panelWidthSmall}px;
    }
  }

  ${StyledAsidePanel} {
    position: sticky;
    top: 0;
    right: 0;
    box-shadow: none;
    animation: none;
    padding-bottom: 68px;

    @media ${mediaBreakpointsDown.tabletLg} {
      width: ${panelWidthSmall}px;
    }

    @media (max-width: ${mobileBreakpoint}px) {
      padding-bottom: 0;
    }
  }

  ${StyledPanelFooter} {
    position: fixed;
    bottom: 0;
    display: flex;
    width: 100%;
    max-width: 400px;

    @media ${mediaBreakpointsDown.tabletLg} {
      max-width: ${panelWidthSmall}px;
    }
  }
`

export const StyledModal = styled(Modal)`
  top: ${spacing.md}px;
  bottom: ${spacing.md}px;
  max-width: 416px;
  transform: none;

  ${StyledModalContent} {
    max-height: 100vh;
  }

  @media (max-width: ${mobileBreakpoint}px) {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
  }
`
